const DATE_FORMAT = 'DD/MM/YYYY';
const DATE_FORMAT_WITH_TIME = 'DD/MM/YYYY HH:mm:ss';

export { DATE_FORMAT, DATE_FORMAT_WITH_TIME };
